/**
 * Element.requestFullScreen() polyfill
 * @author Chris Ferdinandi
 * @license MIT
 */
if (!Element.prototype.requestFullscreen) {
  Element.prototype.requestFullscreen =
    Element.prototype.mozRequestFullscreen ||
    Element.prototype.webkitRequestFullscreen ||
    Element.prototype.msRequestFullscreen;
}

// Can be used for playing video on click of an image or button, example img style="max-width: 100%" alt=("moi") data-video="1AuUX1Y8y7s" src="https://img.youtube.com/vi/1AuUX1Y8y7s/0.jpg"
import $ from 'jquery';

document.addEventListener("turbo:load", function() {
    // Set up click handlers for elements with data-video attribute
    $(document).on("click", "[data-video]", function(event) {
      var videoId = $(this).data("video");
      if (!videoId) return;

      var iframe = document.createElement("div");
      iframe.innerHTML =
        '<p>x</p><iframe src="https://www.youtube.com/embed/' +
        videoId +
        '?rel=0&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
      var video = iframe.childNodes[1];

      $("#video-modal").show();
      $("#videoWrapper").html(video);

      event.preventDefault();
    });

    // Close modal handlers
    $("body").on("click", "#video-modal, #close-modal", function(event) {
      $("#videoWrapper").html("");
      $("#video-modal").hide();
    });

    // if the ESC key is tapped
    $("body").keyup(function(e) {
      if (e.keyCode === 27) {
        $("#videoWrapper").html("");
        $("#video-modal").hide();
      }
    });

    $("#close-modal").click(function() {
      $("#videoWrapper").html("");
      $("#video-modal").hide();
    });
    // video.requestFullscreen();
  },
  false
);
